export const en = {
    'asc-order': 'Older first',
    'desc-order': 'Newer first',
    'order-by-date-label': 'Sort by date'
};
